/**
 * Components / Templates: Quantity Selector
 * ------------------------------------------------------------------------------
 * Handles the quantity selector base template for use in scripts.
 *
 * - Should be kept inline with quantity-selector.liquid.
 * - Built to be used in any component rendering.
 *
 */
import {misc as icons} from '~/helpers/svg-map';
import {decodeHTMLEntities} from '~/helpers/utils';

/**
 * Get quantity selector template.
 * @param {Object} item - Cart item to get properties from.
 * @param {Integer} index - Unique index to bind component to.
 * @param {String} namespace - The namespace of the context.
 * @returns {String}
 */
export default (item, index, namespace = 'quantity-selector') => {
  function getMaxInventory() {
    if (item.properties !== null && item.properties._max_inventory) {
      return item.properties._max_inventory;
    }
    return 999;
  }

  function isFreeGift() {
    return item.properties && item.properties['Free Gift'] === 'Yes';
  }
  function isEngraving() {
    return item.properties?.ENGRAVING !== undefined;
  }


  return `
    <label
      class="visually-hidden"
      for="Quantity-${index}"
      tabindex="0"
    >
      ${decodeHTMLEntities(theme.strings.cart.label.quantity)}
    </label>

    <div
      id="QuantitySelector-${index}"
      class="quantity-selector quantity-selector--small"
      data-available="true"
      data-free-gift="${isFreeGift()}"
      data-engraving="${isEngraving()}"
      data-max="${getMaxInventory()}"
      js-${namespace}="quantitySelector"
    >
      <div class="quantity-selector__control">
        <button
          class="button quantity-selector__button"
          ${isFreeGift() || isEngraving() ? 'disabled="true"' : ''}
          value="decrement"
          js-quantity-selector="decrement"
        >
          <span class="visually-hidden">-</span>
          ${icons.minus}
        </button>
      </div>

      <div class="quantity-selector__control">
        <input
          id="Quantity-${index}"
          class="quantity-selector__input"
          min="1"
          name="quantity"
          pattern="[0-9]*"
          readonly
          type="number"
          value="${item.quantity}"
          js-quantity-selector="input"
        />
      </div>

      <div class="quantity-selector__control">
        <button
          class="button quantity-selector__button"
          ${isFreeGift() || isEngraving() ? 'disabled="true"' : ''}
          value="increment"
          type="button"
          data-cy="quantityIncrease"
          js-quantity-selector="increment"
        >
          <span class="visually-hidden">+</span>
          ${icons.plus}
        </button>
      </div>
    </div>
  `;
};
